import { Route, Switch } from 'react-router-dom';
import Col from '@guestyci/foundation/Layout/Col';

import UserLayout from './shareable/layouts/UserLayout';
import { useAuthorizationContext } from './module/Authorization';
import { AuthRoutes, IRoute, NavRoutes, PermanentRoutes } from './routes';

const getRoutes = (routes: IRoute[]) =>
  routes.map((routeConfig) => {
    const Component = routeConfig.component;
    const props = routeConfig.configurations || {};

    return (
      <Route
        key={routeConfig.path}
        path={routeConfig.path}
        exact={routeConfig.exact}
      >
        <Component {...props} />
      </Route>
    );
  });

const userRoutes = getRoutes(NavRoutes);
const guestRoutes = getRoutes(AuthRoutes);
const permanentRoutes = getRoutes(PermanentRoutes);

const AppRouter = () => {
  const { state } = useAuthorizationContext();
  const Wrapper = state.isAuthorized ? UserLayout : Col;

  return (
    <Wrapper>
      <Switch>
        {permanentRoutes}

        {!state.isAuthorized && guestRoutes}

        {state.isAuthorized && userRoutes}
      </Switch>
    </Wrapper>
  );
};

export default AppRouter;
